import React, { Fragment } from "react";
import { Grid } from "@mui/material";
import { useQuery } from "react-query";
import { getReleasesData } from "../../services/Release";
import InfoTile from "../common/InfoTile";

const ReleaseStats = () => {
  const { data: { data: { releaseCount = 0 } = {} } = {} } = useQuery(
    "getReleasesData",
    getReleasesData,
    {
      refetchOnWindowFocus: false,
      useErrorBoundary: false,
      suspense: true,
    },
  );

  return (
    <Fragment>
      <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }} >
        <InfoTile title={"Total Releases"} info={releaseCount} />
      </Grid>
    </Fragment>
  );
};

ReleaseStats.defaultProps = {};

ReleaseStats.propTypes = {};

export default ReleaseStats;
